"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AccordionItem_1 = __importDefault(require("./AccordionItem"));
exports.default = AccordionItem_1.default;
